<template>
  <button class="go-top-btn" v-scroll-to="{ el: '#app' }"></button>
</template>

<script>
export default {
  name: 'AppGoTopButton',
};
</script>
